import { CommonModule } from '@angular/common';
import { Component, OnInit, Input, Output, EventEmitter, ViewChild } from '@angular/core';
import { DxAutocompleteComponent, DxAutocompleteModule, DxButtonModule } from 'devextreme-angular';

@Component({
    selector: 'app-autocomplete',
    imports: [
        CommonModule,
        DxAutocompleteModule,
        DxButtonModule
    ],
    templateUrl: './autocomplete.component.html',
    styleUrls: ['./autocomplete.component.scss'],
	standalone: true
})
export class AutocompleteComponent implements OnInit {
	selectedIndex = 0;
	public dataSource_: string[] = [];

	@Output()
	public selectedItemChange: EventEmitter<string> = new EventEmitter<string>();

	private _selectedItem: string = '';
	public get selectedItem(): string {
		return this._selectedItem;
	}
	@Input()
	public set selectedItem(value) {
		this._selectedItem = value;

		this.selectedItemChange.emit(this._selectedItem);
	}

	@Input()
	public uploadButtonVisible: boolean = false;

	@Input()
	public set dataSource(arr: string[]) {
		this.dataSource_ = arr;

		if (this.dataSource_ && this.dataSource_.length >= 2) {
			this.isNextButtonVDisabled = false;
		}

		this.LoadDefault(0);

		
		this.checkButtonState(this.selectedIndex);
	};

	@Input() placeHolder = 'Type 3 symbols ';
	@Input() isClearButtonVisible = true;
	@Input() isNextSaveOption = false;
	//loading time disable
	@Input() isNextPreDisable = false;


	isPrevButtonDisabled = true;
	isNextButtonVDisabled = true;
	@Output() productChange = new EventEmitter<string>();
	@Output() SaveProductNext = new EventEmitter<string>();

	@Output() onValueChange = new EventEmitter<string>();
	@Output() onEnterKey = new EventEmitter<string>();
	@Output() valueChanged = new EventEmitter<string>();
	@Output() emptyItem = new EventEmitter();
	@Output() uploadClick = new EventEmitter();

	@ViewChild('autocomplete')
	autocomplete: DxAutocompleteComponent;

	private filterTimer: any;

	constructor() { }

	ngOnInit() {
		this.checkButtonState(this.selectedIndex);
	}

	onItemClick() {
		this.productChange.emit(this.selectedItem);
		const index = this.dataSource_.indexOf(this.selectedItem);
		this.checkButtonState(index);
	}

	onEnterKeyClicked(event: any) {
		if (this.dataSource_ != null && this.dataSource_.length > 0) {
			let filtedValues = this.dataSource_.filter(x => x == this.selectedItem);
			if (filtedValues != null && filtedValues.length == 1) {
				this.selectedItem = filtedValues[0];
				
				this.onItemClick();
			}
			else {
				this.onEnterKey.emit(this.selectedItem);
			}
		} else {
			this.onEnterKey.emit(this.selectedItem);
		}
	}

	onValueChanged(event: any) {
		if (this.filterTimer) {
			clearTimeout(this.filterTimer);
		}

		this.filterTimer = setTimeout(() => {
			if (event.value && event.event && event.value.length >= 3) {

				if (this.valueChanged) {
					this.valueChanged.emit(event.value);
				}
			}

			if (!event.value) {
				this.isPrevButtonDisabled = true;
				this.isNextButtonVDisabled = true;

				if (this.emptyItem) {
					this.emptyItem.emit();
				}
			}
		}, 1000);

		const index = this.dataSource_.indexOf(this.selectedItem);

		if (index >= 0) {
			this.checkButtonState(index);
		}

		this.onValueChange.emit(this.selectedItem);
	}

	checkButtonState(index) {
		if (!this.dataSource_ || this.dataSource_.length === 0) {
			return;
		}

		this.selectedIndex = index;
		this.isNextButtonVDisabled = (index === this.dataSource_.length - 1);
		this.isPrevButtonDisabled = (index === 0);
	}

	LoadDefault(indexShift: number) {
		if (this.selectedItem != null && this.dataSource_.indexOf(this.selectedItem) != null) {
			this.selectedIndex = this.dataSource_.indexOf(this.selectedItem)
		}
		else if (this.selectedItem != null) {
			this.selectedIndex = 0;
		}

		
		if (this.selectedItem == null || this.selectedItem == null) {
			this.selectedIndex = 0;
		}

		let newIndex = this.selectedIndex + indexShift;
		
		this.checkButtonState(newIndex);
	}
	click(indexShift: number) {

		if (this.selectedItem != null && this.dataSource_.indexOf(this.selectedItem) != null) {
			this.selectedIndex = this.dataSource_.indexOf(this.selectedItem)
		}
		else if (this.selectedItem != null) {
			this.selectedIndex = 0;
		}

		if (this.selectedIndex < 0) {


			if (indexShift == -1) {
				this.selectedIndex = 1;
			}
			else if (indexShift == 1) {
				this.selectedIndex = -1;
			}
			else {
				this.selectedIndex = 0;
			}
		}

		
		if (this.selectedItem == null || this.selectedItem == null) {
			this.selectedIndex = 0;
		}

		let newIndex = this.selectedIndex + indexShift;
		this.selectedItem = this.dataSource_[newIndex];
		this.checkButtonState(newIndex);
		this.productChange.emit(this.selectedItem);

	}

	SaveNextclick(indexShift: number) {
		if (this.selectedItem != null && this.dataSource_.indexOf(this.selectedItem) != null) {
			this.selectedIndex = this.dataSource_.indexOf(this.selectedItem)
		}
		else if (this.selectedItem != null) {
			this.selectedIndex = 0;
		}

		if (this.selectedIndex < 0) {


			if (indexShift == -1) {
				this.selectedIndex = 1;
			}
			else if (indexShift == 1) {
				this.selectedIndex = -1;
			}
			else {
				this.selectedIndex = 0;
			}
		}
		if (this.selectedItem == null || this.selectedItem == null) {
			this.selectedIndex = 0;
		}

		let newIndex = this.selectedIndex + indexShift;
		this.selectedItem = this.dataSource_[newIndex];
		this.checkButtonState(newIndex);

		this.SaveProductNext.emit(this.selectedItem);
	}

	UploadChangesChild(indexShift: number) {
		this.uploadClick.emit(this.selectedItem);
	}

	setSelectedItem(value: string) {
		this.selectedItem = value;
		const index = this.dataSource_.indexOf(this.selectedItem);
		this.checkButtonState(index);
	}

		
	@Input() needConfirmation: boolean = false;
	@Input() onNextPrevConfirm!: () => boolean;

	public onNextPrev(indexShift: number) {

	if (this.needConfirmation) {
		const isConfirmed = this.onNextPrevConfirm();
		if (isConfirmed) {
			this.click(indexShift);
		}
		} else {
			this.click(indexShift);
		}
	}
}
